module.exports = __webpack_public_path__ + "static/media/sometimes.002c0e88.mp3";